export const BOTSLIST_CREATE_CONTACT_BUTTON_CLICKED = 'botslist-create-contact-banner-button-clicked';
export const BOTSLIST_HELPCENTER_CLICKED = 'botslist-helpcenter-clicked';
export const BOTSLIST_FORUM_CLICKED = 'botslist-forum-clicked';
export const BOTSLIST_CONTRACTPANNEL_CLICKED = 'botslist-contractpannel-clicked';
export const BOTSLIST_AIAGENT_HOME_CREATE_CLICKED = 'organization-home-aiagent-create-clicked';
export const BOTSLIST_AIAGENT_GET_TO_KNOW_CLICKED = 'organization-home-aiagent-get-to-know-clicked';
export const BOTSLIST_AIAGENT_CREATE_NOW_CLICKED = 'organization-home-aiagent-create-now-clicked';
export const BOTSLIST_AIAGENT_HOME_CREATE_GET_TO_KNOW_CLICKED = 'organization-home-aiagent-create-get-to-know-clicked';
export const APPLICATION_AIAGENT_CREATION_TEMPLATE_TESTED = 'application-aiagent-creation-template-tested';
export const APPLICATION_OPENED = 'application-opened';
export const BOTLIST_PRODUCT_UPDATES_CLICKED = 'botslist-product-updates-clicked';
